import { Fragment, useContext } from "react";

import { useTranslation } from "react-i18next";

import CardItemValue from "components/TableDetails/components/CardItemValue";
import { renderAvailableData } from "components/TableDetails/functions";
import TableContext from "context/table/tableContext";

import { CARD_ITEMS, CARDS } from "../../types";
import { DetailsData } from "../types";

const Carrier = () => {
    const { detailsData } = useContext(TableContext);

    const {
        carrier: {
            unit_status,
            unit_type,
            module_id,
            serial_id,
            version,
            filename
        }
    }: DetailsData = detailsData;

    const { t } = useTranslation();

    const list = [
        {
            title: CARD_ITEMS.CarrierUnitStatus,
            value: unit_status,
            isAvailable: true
        },
        {
            title: CARD_ITEMS.CarrierUnitType,
            value: unit_type,
            isAvailable: true
        },
        {
            title: CARD_ITEMS.CarrierModuleId,
            value: module_id,
            isAvailable: true
        },
        {
            title: CARD_ITEMS.CarrierSerialId,
            value: serial_id,
            isAvailable: true
        },
        {
            title: CARD_ITEMS.CarrierRevision,
            value: version,
            isAvailable: true
        },
        {
            title: CARD_ITEMS.CarrierSettingsFilename,
            value: filename,
            isAvailable: true
        }
    ];

    return (
        <div>
            <div>{t(`Dialog##${CARDS.Carrier}`)}</div>

            <div>
                {renderAvailableData(list).map(({ title, value }) => {
                    return (
                        <Fragment key={title}>
                            <span>{t(`Table##${title}`)}:</span>
                            <CardItemValue value={value} />
                        </Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export { Carrier };
